/* WPC: knoptekst in de snelweergave. Productkaarten geven met data-wpc-nb de varianten door die op
   nabestelling worden verkocht (voorraad 0 of lager, doorgaan met verkopen). theme.js roept wpcAtcText aan. */
(function () {
  window.wpcAtcText = function (variantId) {
    var std = (window.theme && theme.strings && theme.strings.addToCart) || 'Direct bestellen';
    if (!variantId) return std;
    var els = document.querySelectorAll('[data-wpc-nb]');
    for (var i = 0; i < els.length; i++) {
      if ((',' + els[i].getAttribute('data-wpc-nb')).indexOf(',' + variantId + ',') !== -1) return 'PRE-ORDER NU';
    }
    return std;
  };
})();

/* WPC: vaste voorraadteksten in de productsectie wisselen bij een variant op nabestelling (zelfde zinnen als snippets/wpc-nb-text.liquid). */
(function () {
  function pairs(L) {
    return [
      ['Levering binnen 5 werkdagen, of afhalen in Almere.', 'Pre-order · ' + L + '.'],
      ['Bestel vandaag nog en je krijgt het binnen 5 werkdagen geleverd.', 'Dit artikel wordt nabesteld (' + L + ').'],
      ['Bestel vandaag nog en profiteer van snelle levering', 'Nu te bestellen als pre-order'],
      ['Bestel eenvoudig online en profiteer van snelle levering', 'Bestel eenvoudig online als pre-order'],
      ['BESTEL VANDAAG NOG EN PROFITEER VAN SNELLE LEVERING', 'NU TE BESTELLEN ALS PRE-ORDER'],
      ['We leveren uit eigen voorraad.', 'Dit artikel wordt nabesteld.'],
      ['Binnen 5 werkdagen na bestelling', 'pre-orderartikel (' + L + ')'],
      ['Ons eigen team bezorgt je bestelling binnen 5 werkdagen.', 'Ons eigen team bezorgt je bestelling zodra het artikel binnen is.'],
      ['snel uit voorraad', 'zodra de nieuwe voorraad binnen is'],
      ['Levering binnen 5 werkdagen', 'Pre-order · ' + L]
    ];
  }
  window.wpcNbSwap = function (root, toNb, L) {
    if (!root) return;
    var p = pairs(L || 'levertijd op aanvraag');
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.parentNode && /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.parentNode.nodeName)) continue;
      // het thema zet harde spaties (U+00A0) en woordverbinders (U+2060) in teksten
      var o = n.nodeValue, t = o.replace(/\u00a0/g, ' ').replace(/\u2060/g, ''), hit = false;
      for (var i = 0; i < p.length; i++) {
        var a = toNb ? p[i][0] : p[i][1], b = toNb ? p[i][1] : p[i][0];
        if (t.indexOf(a) !== -1) { t = t.split(a).join(b); hit = true; }
      }
      if (hit) n.nodeValue = t;
    }
  };
})();
